import {RouteRecordRaw } from 'vue-router'
// 路由

/**
 * meta:{
 *     title:'登录', 页面标题/菜单标题
 *     icon:'',     菜单图标
 *     hidden:true, 是否在菜单中以隐藏
 *     hiddenTab:true 是否在tab栏中隐藏
 *     role: 角色权限
 * }
 */

 export const commonRoutes: Array<RouteRecordRaw> = [
    {
      path: '/',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/home',
      meta:{
        title:'首页',
        icon:'dashboard'
      },
      children: [{
        path:'/home',
        name:'home',
        component: ()=>import('@/views/Home/home.vue'),
        meta:{
          title:'首页',
          icon:''
        },
      }]
    },
    // 登录
    {
      path: '/login',
      name:'login',
      component: ()=>import('@/views/Login/index.vue'),
      meta:{
        title:'登录',
        icon:'',
        hidden:true,
        hiddenTab:true
      }
    },
    // 个人中心
    {
      path: '/user',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/user/userInfo',
      meta:{
        title:'个人中心',
        icon:'user',
        hidden:true,
        hiddenTab:true
      },
      children: [{
        path:'userInfo',
        name:'userInfo',
        component: ()=>import('@/views/userCenter/userInfo.vue'),
        meta:{
          title:'个人中心',
          icon:''
        },
      }]
    },
  //  会员卡管理
    {
      path: '/card',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/card/cardManage',
      meta:{
        title:'会员卡管理',
        icon:'card',
        role: ["property","staff"],
      },
      children: [{
        path:'cardManage',
        name:'cardManage',
        component: ()=>import('@/views/cardManage/cardManage.vue'),
        meta:{
          title:'会员卡管理',
          icon:''
        },
      }]
    },
     //  会员卡管理
     {
      path: '/couponp',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/couponp/couponpm',
      meta:{
        title:'福利管理',
        icon:'card',
        role: ['store_staff','store_staffManager','commerce'],
      },
      children: [{
        path:'couponpm',
        name:'couponpm',
        component: ()=>import('@/views/couponPackageManage/couponPackageManage.vue'),
        meta:{
          title:'福利管理',
          icon:''
        },
      }]
    },
    //  物业
    {
      path: '/property',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/property/index',
      meta:{
        title:'物业列表',
        icon:'community',
        role: ["cooperator"],
      },
      children: [{
        path:'index',
        name:'propertyindex',
        component: ()=>import('@/views/propertyManage/index.vue'),
        meta:{
          title:'物业列表',
          icon:''
        },
      }]
    },
     //  小区
     {
      path: '/community',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/community/index',
      meta:{
        title:'小区列表',
        icon:'community',
        role: ["property"],
      },
      children: [{
        path:'index',
        name:'community',
        component: ()=>import('@/views/communityManage/index.vue'),
        meta:{
          title:'小区列表',
          icon:''
        },
      }]
    },
     //  收益管理
     {
      path: '/income',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/income/incomeManage',
      meta:{
        title:'收益管理',
        icon:'income',
        role:["cooperator","property","commerce"]
      },
      children: [{
        path:'incomeManage',
        name:'incomeManage',
        component: ()=>import('@/views/incomeManage/index.vue'),
        meta:{
          title:'收益详情',
          icon:''
        },
      },{
        path:'account',
        name:'account',
        component: ()=>import('@/views/incomeManage/account.vue'),
        meta:{
          title:'账户管理',
          icon:''
        },
      }]
    },
     //  物业员工管理
     {
      path: '/staff',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/staff/staffManage',
      meta:{
        title:'员工管理',
        icon:'user',
        role: ["property"],
      },
      children: [{
        path:'staffManage',
        name:'staffManage',
        component: ()=>import('@/views/staffManage/index.vue'),
        meta:{
          title:'员工管理',
          icon:''
        },
      }]
    },
     //  商会员工管理
     {
      path: '/staff_s',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/staff_s/staffManage',
      meta:{
        title:'员工管理',
        icon:'user',
        role: ['store_staffManager',"commerce"],
      },
      children: [{
        path:'staffManage',
        name:'staffManage',
        component: ()=>import('@/views/storeStaffManage/index.vue'),
        meta:{
          title:'员工管理',
          icon:''
        },
      }]
    },
     //  员工收益管理
     {
      path: '/staffincome',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/staffincome/income',
      meta:{
        title:'收益管理',
        icon:'income',
        role: ["staff","staffManager",'staffKeeper','store_staff','store_staffManager']
      },
      children: [{
        path:'income',
        name:'staffincome',
        component: ()=>import('@/views/staffIncome/index.vue'),
        meta:{
          title:'收益详情',
          icon:''
        },
      },{
        path:'account',
        name:'saccount',
        component: ()=>import('@/views/staffIncome/account.vue'),
        meta:{
          title:'账户管理',
          icon:''
        },
      }]
    },
      //  分享
      {
        path: '/share',
        component: ()=>import('@/layout/index.vue'),
        redirect:'/share/storeShare',
        meta:{
          title:'分享',
          icon:'card',
          role: ['store_staff','store_staffManager','commerce'],
        },
        children: [{
          path:'storeShare',
          name:'storeShare',
          component: ()=>import('@/views/shareManage/storeShare.vue'),
          meta:{
            title:'分享',
            icon:''
          },
        }]
      },


      //--------------设备投资人------
      //  设备管理
    {
      path: '/card',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/card/cardManage',
      meta:{
        title:'设备管理',
        icon:'card',
        role: ["device_invest"],
      },
      children: [{
        path:'cardManage',
        name:'cardManage',
        component: ()=>import('@/views/cardManage/cardManage.vue'),
        meta:{
          title:'会员卡管理',
          icon:''
        },
      }]
    },
     //  业务管理
     {
      path: '/card',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/card/cardManage',
      meta:{
        title:'业务管理',
        icon:'card',
        role: ["device_invest"],
      },
      children: [{
        path:'cardManage',
        name:'cardManage',
        component: ()=>import('@/views/cardManage/cardManage.vue'),
        meta:{
          title:'会员卡管理',
          icon:''
        },
      }]
    },
     //  营运管理
     {
      path: '/card',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/card/cardManage',
      meta:{
        title:'营运管理',
        icon:'card',
        role: ["device_invest"],
      },
      children: [{
        path:'cardManage',
        name:'cardManage',
        component: ()=>import('@/views/cardManage/cardManage.vue'),
        meta:{
          title:'会员卡管理',
          icon:''
        },
      }]
    },
     //  收益管理
     {
      path: '/card',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/card/cardManage',
      meta:{
        title:'收益管理',
        icon:'card',
        role: ["device_invest"],
      },
      children: [{
        path:'cardManage',
        name:'cardManage',
        component: ()=>import('@/views/cardManage/cardManage.vue'),
        meta:{
          title:'会员卡管理',
          icon:''
        },
      }]
    },
    //
    {
      path: '/:path(.*)*',
      component: ()=>import('@/views/err/404.vue'),
      meta:{
        title:'404',
        icon:'',
        hidden:true,
        hiddenTab:true
      }
    }
  ]